import { jsx as _jsx } from "react/jsx-runtime";
import { forwardRef } from 'react';
import styled from 'styled-components';
import { colors } from '@/theme/colors';
export const Input = forwardRef(({ placeholder, value, onChange, onBlur, onFocus, disabled = false, size = 'medium', className = '', type = 'text', name, id, required, autoComplete, ...props }, ref) => {
    const sizeClass = `legarta-input--${size}`;
    return (_jsx(StyledInput, { ref: ref, type: type, placeholder: placeholder, value: value, onChange: onChange, onBlur: onBlur, onFocus: onFocus, disabled: disabled, className: `legarta-input ${sizeClass} ${className}`, name: name, id: id, required: required, autoComplete: autoComplete, ...props }));
});
Input.displayName = 'Input';
const StyledInput = styled.input `
  width: 100%;
  border: 2px solid ${colors.borderMedium};
  border-radius: 8px;
  font-family: inherit;
  font-size: 14px;
  line-height: 1.5;
  transition: all 0.3s ease;
  background: ${colors.backgroundLight};
  color: ${colors.textPrimary};

  &::placeholder {
    color: ${colors.textSecondary};
    opacity: 0.7;
  }

  &:focus {
    outline: none;
    border-color: ${colors.primary};
    box-shadow: 0 0 0 3px ${colors.shadowPrimary}20;
  }

  &:hover:not(:focus) {
    border-color: ${colors.borderDark};
  }

  &:disabled {
    background: ${colors.backgroundLight};
    color: ${colors.textLight};
    cursor: not-allowed;
    border-color: ${colors.borderLight};
  }

  &.legarta-input--small {
    padding: 6px 12px;
    height: 32px;
    font-size: 13px;
  }

  &.legarta-input--medium {
    padding: 8px 16px;
    height: 40px;
    font-size: 14px;
  }

  &.legarta-input--large {
    padding: 12px 20px;
    height: 48px;
    font-size: 16px;
  }
`;
